import { render, staticRenderFns } from "./SelectionSummary.vue?vue&type=template&id=c5a5b8b2&scoped=true&"
import script from "./SelectionSummary.vue?vue&type=script&lang=js&"
export * from "./SelectionSummary.vue?vue&type=script&lang=js&"
import style0 from "./SelectionSummary.vue?vue&type=style&index=0&id=c5a5b8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5b8b2",
  null
  
)

export default component.exports